<template>
  <div>
    <router-view />
  </div>
</template>

<style lang="scss">
@import "./assets/all";
</style>
